import { ComboboxItem, OptionsFilter } from '@mantine/core'
import uniq from 'lodash-es/uniq'
import { TableColumn, FilterableColumn } from './types'

/** Columns offered in the sort/filter selects: visible and not explicitly unsortable, alphabetised. */
export const buildFilterableColumns = <T>(columns: TableColumn<T>[]): FilterableColumn[] =>
  columns
    .filter(col => col.sortable !== false && col.visible)
    .map(col => ({ label: col.label, value: String(col.key) }))
    .sort((a, b) => a.label.localeCompare(b.label))

/** Unique, stringified, non-null values of the selected filter field (search autocomplete options). */
export const getFilterOptions = <T>(data: T[], filterField: keyof T | undefined): string[] => {
  if (!filterField) return []
  return uniq(
    data
      .map(item => item[filterField])
      .filter(value => value !== null && value !== undefined)
      .map(String)
  )
}

/** Case-insensitive, trimmed substring filter for the search autocomplete, sorted by label. */
export const optionsFilter: OptionsFilter = ({ options, search }) => {
  const filtered = (options as ComboboxItem[]).filter(option =>
    option.label
      .toLocaleLowerCase()
      .trim()
      .includes(search?.toLocaleLowerCase().trim() || '')
  )

  filtered.sort((a, b) => a.label.localeCompare(b.label))
  return filtered
}
